import {
  EDO_VENDOR,
  TECHNICAL_PURPOSE,
  DidomiUtils,
} from '../utils/DidomiUtils';

/**
 * Checks whether a given storage entry (cookie/localStorage/sessionStorage key) is allowed under the user's current consent.
 * @param {string} storage - Storage type ('cookies', 'localStorage' or 'sessionStorage').
 * @param {string} key - Key name to check within the storage's consent info.
 * @returns {boolean} True if the entry's vendor/purposes are allowed (or it's a technical entry), false otherwise.
 */
export const isAllowed = (storage, key) => {
  const { vendor, purposes } = DidomiUtils.getValuesInPropertiesFromKey(
    storage,
    key
  );
  const isTechnical =
    vendor === EDO_VENDOR &&
    purposes.length === 1 &&
    purposes[0] === TECHNICAL_PURPOSE;
  let isAllowed = isTechnical;

  if (!isTechnical && vendor && purposes.length > 0) {
    const userStatus = DidomiUtils.getUserStatus();
    const isVendorAllowed = DidomiUtils.isVendorAllowed(vendor, userStatus);
    const isPurposesAllowed = DidomiUtils.isPurposesAllowed(
      purposes,
      userStatus
    );
    isAllowed = isVendorAllowed && isPurposesAllowed;
  }
  return isAllowed;
};
